import PlayIcon from "@mui/icons-material/PlayCircleFilledRounded";
import { IconButton } from "@mui/material";
import React, { FC } from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { IPlayerWrapper } from "./IPlayerWrapper";
import styles from "./PlayerWrapper.module.scss";
import ClickToUnmuteCta from "./ClickToUnmuteCta/ClickToUnmuteCta";

const PlayerWrapper: FC<IPlayerWrapper> = ({
    children,
    showPlayCta,
    showUnmuteCta,
    showControlsLayer,
    isYouTubeVideo,
    onClickPlay,
    onClickUnmute,
    className,
    customPlayIcon,
}) => {
    return (
        <div
            className={classNames(className, styles.root)}
            onClick={showControlsLayer ? undefined : onClickPlay}
        >
            {children}

            {showPlayCta ? (
                <IconButton className={styles.playCta} onClick={onClickPlay}>
                    {customPlayIcon || <PlayIcon />}
                </IconButton>
            ) : null}

            {showUnmuteCta ? (
                <ClickToUnmuteCta
                    className={classNames(
                        styles.unmuteCta,
                        isYouTubeVideo && styles.ytUnmuteCta // prevent overlapping with YT player's default controls
                    )}
                    onClick={onClickUnmute}
                />
            ) : null}

            {showPlayCta ? <div className={styles.backdrop} /> : null}

            {showControlsLayer ? (
                <div className={styles.controlsLayer} onClick={onClickPlay} />
            ) : null}
        </div>
    );
};

export default PlayerWrapper;
